import request from '@/api/httpRequest2'

// 查询协作者列表
export function listCollaborators(query) {
  return request({
    url: '/klgeek/collaborator/list',
    method: 'get',
    params: query
  })
}

// 查询协作者详细
export function getCollaborator(id) {
  return request({
    url: '/klgeek/collaborator/' + id,
    method: 'get'
  })
}

// 新增协作者
export function addCollaborator(data) {
  return request({
    url: '/klgeek/collaborator',
    method: 'post',
    data: data
  })
}

// 修改协作者
export function updateCollaborator(data) {
  return request({
    url: '/klgeek/collaborator',
    method: 'put',
    data: data
  })
}

// 删除协作者
export function delCollaborator(id) {
  return request({
    url: '/klgeek/collaborator/' + id,
    method: 'delete'
  })
}

// 检查用户是否有权限访问知识库
export function checkPermission(knowledgeId) {
  return request({
    url: `/klgeek/collaborator/check/${knowledgeId}`,
    method: 'get'
  })
}

// 获取用户在知识库中的角色
export function getUserRole(knowledgeId) {
  return request({
    url: `/klgeek/collaborator/role/${knowledgeId}`,
    method: 'get'
  })
} 